import * as actionTypes from './actionTypes';
import gtagEvent from '../../services/gtagEvent';

// create Single Task

export const createTaskSingle = (task) => {
  // gtagEvent(actionTypes.CREATE_TASK_SINGLE);
  return { type: actionTypes.CREATE_TASK_SINGLE, payload: { task } };
};

export const createTaskSingleStart = () => {
  // gtagEvent(actionTypes.CREATE_TASK_SINGLE_START);
  return { type: actionTypes.CREATE_TASK_SINGLE_START };
};

export const createTaskSingleSuccess = () => {
  gtagEvent(actionTypes.CREATE_TASK_SINGLE_SUCCESS);
  return { type: actionTypes.CREATE_TASK_SINGLE_SUCCESS };
};

export const createTaskSingleFail = (error) => {
  gtagEvent(actionTypes.CREATE_TASK_SINGLE_FAIL);
  return { type: actionTypes.CREATE_TASK_SINGLE_FAIL, payload: { error } };
};

// create Regular Task

export const createTaskRegular = (task) => {
  // gtagEvent(actionTypes.CREATE_TASK_REGULAR);
  return { type: actionTypes.CREATE_TASK_REGULAR, payload: { task } };
};

export const createTaskRegularStart = () => {
  // gtagEvent(actionTypes.CREATE_TASK_REGULAR_START);
  return { type: actionTypes.CREATE_TASK_REGULAR_START };
};

export const createTaskRegularSuccess = () => {
  gtagEvent(actionTypes.CREATE_TASK_REGULAR_SUCCESS);
  return { type: actionTypes.CREATE_TASK_REGULAR_SUCCESS };
};

export const createTaskRegularFail = (error) => {
  gtagEvent(actionTypes.CREATE_TASK_REGULAR_FAIL);
  return { type: actionTypes.CREATE_TASK_REGULAR_FAIL, payload: { error } };
};

// create DELAYED Task

export const createTaskDelayed = (task) => {
  // gtagEvent(actionTypes.CREATE_TASK_DELAYED);
  return { type: actionTypes.CREATE_TASK_DELAYED, payload: { task } };
};

export const createTaskDelayedStart = () => {
  // gtagEvent(actionTypes.CREATE_TASK_DELAYED_START);
  return { type: actionTypes.CREATE_TASK_DELAYED_START };
};

export const createTaskDelayedSuccess = () => {
  gtagEvent(actionTypes.CREATE_TASK_DELAYED_SUCCESS);
  return { type: actionTypes.CREATE_TASK_DELAYED_SUCCESS };
};

export const createTaskDelayedFail = (error) => {
  gtagEvent(actionTypes.CREATE_TASK_DELAYED_FAIL);
  return { type: actionTypes.CREATE_TASK_DELAYED_FAIL, payload: { error } };
};

// create Global Task

export const createTaskGlobal = (task) => {
  // gtagEvent(actionTypes.CREATE_TASK_GLOBAL);
  return { type: actionTypes.CREATE_TASK_GLOBAL, payload: { task } };
};

export const createTaskGlobalStart = () => {
  // gtagEvent(actionTypes.CREATE_TASK_GLOBAL_START);
  return { type: actionTypes.CREATE_TASK_GLOBAL_START };
};

export const createTaskGlobalSuccess = () => {
  gtagEvent(actionTypes.CREATE_TASK_GLOBAL_SUCCESS);
  return { type: actionTypes.CREATE_TASK_GLOBAL_SUCCESS };
};

export const createTaskGlobalFail = (error) => {
  gtagEvent(actionTypes.CREATE_TASK_GLOBAL_FAIL);
  return { type: actionTypes.CREATE_TASK_GLOBAL_FAIL, payload: { error } };
};

// update Single Task

export const updateTaskSingle = (task, loadingDelay = 0) => {
  // gtagEvent(actionTypes.UPDATE_TASK_SINGLE);
  return { type: actionTypes.UPDATE_TASK_SINGLE, payload: { task, loadingDelay } };
};

export const updateTaskSingleStart = () => {
  // gtagEvent(actionTypes.UPDATE_TASK_SINGLE_START);
  return { type: actionTypes.UPDATE_TASK_SINGLE_START };
};

export const updateTaskSingleSuccess = () => {
  gtagEvent(actionTypes.UPDATE_TASK_SINGLE_SUCCESS);
  return { type: actionTypes.UPDATE_TASK_SINGLE_SUCCESS };
};

export const updateTaskSingleFail = (error) => {
  gtagEvent(actionTypes.UPDATE_TASK_SINGLE_FAIL);
  return { type: actionTypes.UPDATE_TASK_SINGLE_FAIL, payload: { error } };
};

// update Regular Task

export const updateTaskRegular = (task, isTasksSingleTitlesUpdated, loadingDelay = 0) => {
  // gtagEvent(actionTypes.UPDATE_TASK_REGULAR);
  return {
    type: actionTypes.UPDATE_TASK_REGULAR,
    payload: {
      task,
      isTasksSingleTitlesUpdated,
      loadingDelay,
    },
  };
};

export const updateTaskRegularStart = () => {
  // gtagEvent(actionTypes.UPDATE_TASK_REGULAR_START);
  return { type: actionTypes.UPDATE_TASK_REGULAR_START };
};

export const updateTaskRegularSuccess = () => {
  gtagEvent(actionTypes.UPDATE_TASK_REGULAR_SUCCESS);
  return { type: actionTypes.UPDATE_TASK_REGULAR_SUCCESS };
};

export const updateTaskRegularFail = (error) => {
  gtagEvent(actionTypes.UPDATE_TASK_REGULAR_FAIL);
  return { type: actionTypes.UPDATE_TASK_REGULAR_FAIL, payload: { error } };
};

// update DELAYED Task

export const updateTaskDelayed = (task, loadingDelay = 0) => {
  // gtagEvent(actionTypes.UPDATE_TASK_DELAYED);
  return { type: actionTypes.UPDATE_TASK_DELAYED, payload: { task, loadingDelay } };
};

export const updateTaskDelayedStart = () => {
  // gtagEvent(actionTypes.UPDATE_TASK_DELAYED_START);
  return { type: actionTypes.UPDATE_TASK_DELAYED_START };
};

export const updateTaskDelayedSuccess = () => {
  gtagEvent(actionTypes.UPDATE_TASK_DELAYED_SUCCESS);
  return { type: actionTypes.UPDATE_TASK_DELAYED_SUCCESS };
};

export const updateTaskDelayedFail = (error) => {
  gtagEvent(actionTypes.UPDATE_TASK_DELAYED_FAIL);
  return { type: actionTypes.UPDATE_TASK_DELAYED_FAIL, payload: { error } };
};

// update Global Task

export const updateTaskGlobal = (task, loadingDelay = 0) => {
  // gtagEvent(actionTypes.UPDATE_TASK_GLOBAL);
  return { type: actionTypes.UPDATE_TASK_GLOBAL, payload: { task, loadingDelay } };
};

export const updateTaskGlobalStart = () => {
  // gtagEvent(actionTypes.UPDATE_TASK_GLOBAL_START);
  return { type: actionTypes.UPDATE_TASK_GLOBAL_START };
};

export const updateTaskGlobalSuccess = () => {
  gtagEvent(actionTypes.UPDATE_TASK_GLOBAL_SUCCESS);
  return { type: actionTypes.UPDATE_TASK_GLOBAL_SUCCESS };
};

export const updateTaskGlobalFail = (error) => {
  gtagEvent(actionTypes.UPDATE_TASK_GLOBAL_FAIL);
  return { type: actionTypes.UPDATE_TASK_GLOBAL_FAIL, payload: { error } };
};

// remove Single Task

export const removeTaskSingle = (id) => {
  // gtagEvent(actionTypes.REMOVE_TASK_SINGLE);
  return { type: actionTypes.REMOVE_TASK_SINGLE, payload: { id } };
};

export const removeTaskSingleStart = () => {
  // gtagEvent(actionTypes.REMOVE_TASK_SINGLE_START);
  return { type: actionTypes.REMOVE_TASK_SINGLE_START };
};

export const removeTaskSingleSuccess = () => {
  gtagEvent(actionTypes.REMOVE_TASK_SINGLE_SUCCESS);
  return { type: actionTypes.REMOVE_TASK_SINGLE_SUCCESS };
};

export const removeTaskSingleFail = (error) => {
  gtagEvent(actionTypes.REMOVE_TASK_SINGLE_FAIL);
  return { type: actionTypes.REMOVE_TASK_SINGLE_FAIL, payload: { error } };
};

// remove Regular Task

export const removeTaskRegular = (id) => {
  // gtagEvent(actionTypes.REMOVE_TASK_REGULAR);
  return { type: actionTypes.REMOVE_TASK_REGULAR, payload: { id } };
};

export const removeTaskRegularStart = () => {
  // gtagEvent(actionTypes.REMOVE_TASK_REGULAR_START);
  return { type: actionTypes.REMOVE_TASK_REGULAR_START };
};

export const removeTaskRegularSuccess = () => {
  gtagEvent(actionTypes.REMOVE_TASK_REGULAR_SUCCESS);
  return { type: actionTypes.REMOVE_TASK_REGULAR_SUCCESS };
};

export const removeTaskRegularFail = (error) => {
  gtagEvent(actionTypes.REMOVE_TASK_REGULAR_FAIL);
  return { type: actionTypes.REMOVE_TASK_REGULAR_FAIL, payload: { error } };
};

// remove DELAYED Task

export const removeTaskDelayed = (id) => {
  // gtagEvent(actionTypes.REMOVE_TASK_DELAYED);
  return { type: actionTypes.REMOVE_TASK_DELAYED, payload: { id } };
};

export const removeTaskDelayedStart = () => {
  // gtagEvent(actionTypes.REMOVE_TASK_DELAYED_START);
  return { type: actionTypes.REMOVE_TASK_DELAYED_START };
};

export const removeTaskDelayedSuccess = () => {
  gtagEvent(actionTypes.REMOVE_TASK_DELAYED_SUCCESS);
  return { type: actionTypes.REMOVE_TASK_DELAYED_SUCCESS };
};

export const removeTaskDelayedFail = (error) => {
  gtagEvent(actionTypes.REMOVE_TASK_DELAYED_FAIL);
  return { type: actionTypes.REMOVE_TASK_DELAYED_FAIL, payload: { error } };
};

// remove Global Task

export const removeTaskGlobal = (id) => {
  // gtagEvent(actionTypes.REMOVE_TASK_GLOBAL);
  return { type: actionTypes.REMOVE_TASK_GLOBAL, payload: { id } };
};

export const removeTaskGlobalStart = () => {
  // gtagEvent(actionTypes.REMOVE_TASK_GLOBAL_START);
  return { type: actionTypes.REMOVE_TASK_GLOBAL_START };
};

export const removeTaskGlobalSuccess = () => {
  gtagEvent(actionTypes.REMOVE_TASK_GLOBAL_SUCCESS);
  return { type: actionTypes.REMOVE_TASK_GLOBAL_SUCCESS };
};

export const removeTaskGlobalFail = (error) => {
  gtagEvent(actionTypes.REMOVE_TASK_GLOBAL_FAIL);
  return { type: actionTypes.REMOVE_TASK_GLOBAL_FAIL, payload: { error } };
};

// get tasks

export const getTasksServer = () => {
  // gtagEvent(actionTypes.GET_TASKS_SERVER);
  return { type: actionTypes.GET_TASKS_SERVER };
};

export const getTasksServerStart = () => {
  // gtagEvent(actionTypes.GET_TASKS_SERVER_START);
  return { type: actionTypes.GET_TASKS_SERVER_START };
};

export const getTasksServerSuccess = (tasks) => {
  gtagEvent(actionTypes.GET_TASKS_SERVER_SUCCESS);
  return { type: actionTypes.GET_TASKS_SERVER_SUCCESS, payload: { tasks } };
};

export const getTasksServerFail = (error) => {
  gtagEvent(actionTypes.GET_TASKS_SERVER_FAIL);
  return { type: actionTypes.GET_TASKS_SERVER_FAIL, payload: { error } };
};
